// ======================================================================
// File Name       : CourseListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CourseTreeContainer from './CourseTreeContainer';
import ModalConductor from '../../components/modal/ModalConductor';
import CourseSearchForm from '../../components/course/CourseSearchForm';
import * as containerAction from '../../actions/ContainerAction';
import * as userAction from '../../actions/UserAction';
import * as courseAction from '../../actions/CourseAction';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import DialogConfirm from '../../components/DialogConfirm';
import { showExportCSVSuccessMessage, isSuperUser } from '../../utils/index';
import { STRUCTURE_TYPE, NEW_COURSE_MANAGEMENT_URL, COURSE_LAYOUT_TYPE } from '../../constants';
import { BULK_EXPORT } from '../../constants/MessageTemplate';
import store from '../../store';
import { Col } from 'react-bootstrap';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class CourseListContainer extends Component {
  constructor() {
    super();
    this.state = {
      isAllowShowSearchMessage: false,
      resultList: [],

      showDelete: false,
      showExportConfirm: false,
    };
    this.dismissMessage = this.dismissMessage.bind(this);
    this.updateSearchResult = this.updateSearchResult.bind(this);

    this.onOkDelete = this.onOkDelete.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleExportBtn = this.handleExportBtn.bind(this);
    this.onOkExport = this.onOkExport.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(containerAction.init());
    this.formSubmit = this.formSubmit.bind(this);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(containerAction.destroy());
  }

  formSubmit() {
    this.refs.treeRef.getWrappedInstance().handleSearchBtn();
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false, resultList: [] });
  }

  updateSearchResult(isAllowShowSearchMessage, resultList) {
    this.setState({ isAllowShowSearchMessage, resultList });
  }

  handleDelete(data) {
    const { dispatch } = this.props;
    const { structureSecernId } = data;
    const structureType = dispatch(containerAction.getStructureType(structureSecernId));
    let structureTypeName;
    switch (structureType) {
      case STRUCTURE_TYPE.COURSE:
        structureTypeName = 'コース';
        break;

      case STRUCTURE_TYPE.BOX:
        structureTypeName = 'セクション';
        break;

      case STRUCTURE_TYPE.ITEM:
        structureTypeName = 'アイテム';
        break;

      default:
        structureTypeName = 'データ';
        break;
    }
    this.setState({ showDelete: true, structureSecernId, structureTypeName });
  }

  onOkDelete() {
    const { dispatch } = this.props;
    const { structureSecernId } = this.state;
    dispatch(containerAction.openDeleteDialog(structureSecernId));
    this.setState({ showDelete: false });
  }

  handleExportBtn() {
    this.setState({ showExportConfirm: true });
  }

  onOkExport() {
    this.setState(
      {
        showExportConfirm: false,
      },
      () => {
        this.props.dispatch(containerAction.exportCSV()).then(() => {
          showExportCSVSuccessMessage();
        });
      },
    );
  }

  redirectToNewCourseScreen() {
    window.saveItem('courseLayoutType', COURSE_LAYOUT_TYPE.NEW);
    window.sendItem('courseLayoutType', COURSE_LAYOUT_TYPE.NEW);
    window.location.href = NEW_COURSE_MANAGEMENT_URL;
  }

  render() {
    const { resultList, isAllowShowSearchMessage } = this.state;

    return (
      <div>
        <MessageSearch
          recordNum={resultList && resultList.length ? resultList.length : 0}
          resultList={resultList}
          isAllowShowSearchMessage={isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="padding-left-right-clear label-middle">
          <Header name="コース" />
          <CustomLink
            className="margin-right-7 inline-flex line-height-20 padding-left-30 padding-bottom-15 margin-top-15"
            onClick={this.redirectToNewCourseScreen}
            text="新しいレイアウトを使う"
          />
        </Col>
        <CourseSearchForm ref="searchForm" formSubmit={this.formSubmit} />
        <CourseTreeContainer
          history={this.props.history}
          ref="treeRef"
          updateSearchResult={this.updateSearchResult.bind(this)}
          handleExportBtn={this.handleExportBtn}
          handleDelete={this.handleDelete}
        />
        <DialogConfirm
          showModal={this.state.showDelete}
          onCancel={() => this.setState({ showDelete: false })}
          content={
            <div>
              {`対象の${this.state.structureTypeName}を削除しますが`}
              {<br />}よろしいですか？
            </div>
          }
          onOK={this.onOkDelete}
          animation={false}
        />
        <DialogConfirm
          showModal={this.state.showExportConfirm}
          onCancel={() => this.setState({ showExportConfirm: false })}
          content={BULK_EXPORT}
          onOK={this.onOkExport}
          animation={false}
        />
        <ModalConductor />
      </div>
    );
  }
}

CourseListContainer.propTypes = propTypes;
const mapStateToProps = (state, ownProps) => {
  return {
  };
};
export default connect(mapStateToProps)(CourseListContainer);
